import React from 'react';
import { useTheme } from '@mui/material';

export const PDF = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M18.5 14c-.825 0-1.5.675-1.5 1.5V44h30V15.5c0-.825-.675-1.5-1.5-1.5h-27ZM50 15.5V44h1.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5h-39c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5H14V15.5c0-2.484 2.016-4.5 4.5-4.5h27c2.484 0 4.5 2.016 4.5 4.5ZM9.5 38H11v3H9.5c-.825 0-1.5.675-1.5 1.5v6c0 .825.675 1.5 1.5 1.5h45c.825 0 1.5-.675 1.5-1.5v-6c0-.825-.675-1.5-1.5-1.5H53v-3h1.5c2.484 0 4.5 2.016 4.5 4.5v6c0 2.484-2.016 4.5-4.5 4.5h-45A4.501 4.501 0 0 1 5 48.5v-6C5 40.016 7.016 38 9.5 38Zm31.06-13.688-10.004 9.994a1.505 1.505 0 0 1-2.119 0l-4.996-4.997a1.505 1.505 0 0 1 0-2.118 1.505 1.505 0 0 1 2.118 0l3.938 3.937 8.944-8.944a1.505 1.505 0 0 1 2.118 0 1.505 1.505 0 0 1 0 2.12v.009Z"
            />
        </svg>
    );
};

export default PDF;
